'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.transformCatchExpression = transformCatchExpression;

var _types = require('../types');

var _types2 = _interopRequireDefault(_types);

var _tails = require('../helpers/tails');

var _astLocUtils = require('ast-loc-utils');

var _match = require('./match');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function transformVarDeclCatchExpression(path, catchExprPath, isLinter) {
  var node = catchExprPath.node;


  var resRef = path.scope.generateUidIdentifier("val");
  var errRef = (0, _astLocUtils.placeAtLoc)(path.scope.generateUidIdentifier("err"), (0, _astLocUtils.span)((0, _astLocUtils.getLoc)(node), 1));
  var catchBody = (0, _match.transformMatchCases)((0, _match.getMatchInfo)(catchExprPath, errRef, isLinter), catchExprPath.get("cases"));

  path.insertBefore(_types2.default.variableDeclaration("let", [_types2.default.variableDeclarator(resRef)]));
  path.insertBefore(_types2.default.tryStatement(
  // try { _val = expr }
  _types2.default.blockStatement([_types2.default.expressionStatement(_types2.default.assignmentExpression("=", resRef, node.expression))])
  // catch (err) { ... }
  , _types2.default.catchClause(errRef, _types2.default.blockStatement([catchBody]))));
  // x = _val
  var declaratorPath = path.get("declarations.0");
  declaratorPath.node.init = resRef;
  // Transform tails in the catch-clause to assignments
  var tryPath = path.getPrevSibling();
  (0, _tails.transformTails)(tryPath.get("handler.body"), false, false, function (node) {
    return (0, _astLocUtils.placeAtNode)(_types2.default.assignmentExpression("=", resRef, node), node);
  });
}function transformPessimizedCatchExpression(path, isLinter) {
  var node = path.node;


  var errRef = (0, _astLocUtils.placeAtLoc)(path.scope.generateUidIdentifier("err"), (0, _astLocUtils.span)((0, _astLocUtils.getLoc)(node), 1));
  var catchBody = (0, _match.transformMatchCases)((0, _match.getMatchInfo)(path, errRef, isLinter), path.get("cases"));

  var iife = _types2.default.callExpression(_types2.default.arrowFunctionExpression([], _types2.default.blockStatement([_types2.default.tryStatement(_types2.default.blockStatement([_types2.default.returnStatement(node.expression)]), _types2.default.catchClause(errRef, _types2.default.blockStatement([catchBody])))]), (0, _types.isa)(node.expression, "AwaitExpression") // async
  ), []);

  path.replaceWith(iife);
}function isVarDeclCatchExpr(path) {
  return (0, _types.isa)(path.parent, "VariableDeclarator") && path.parentPath.parent.declarations.length === 1 && path.parentPath.parentPath.listKey === "body";
}function transformCatchExpression(path, isLinter) {
  if (isVarDeclCatchExpr(path)) {
    transformVarDeclCatchExpression(path.parentPath.parentPath, path, isLinter);
  } else {
    transformPessimizedCatchExpression(path, isLinter);
  }
}